import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Provider } from 'react-redux';
import { store } from "../store";
import { CacheProvider } from "@emotion/react";
import { Box, ChakraProvider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Portal, useDisclosure } from "@chakra-ui/react";
import { theme } from "../theme";
import createCache from "@emotion/cache";
import { createRoot } from "react-dom/client";
import { Form } from "./Form";
const WrapperWithModal = (props) => {
    const ref = useRef(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [heading, setHeading] = useState(null);
    useEffect(() => {
        props.bindOpen(onOpen);
    }, [onOpen]);
    const headerTitle = useMemo(() => {
        if (heading) {
            return heading;
        }
        if (props.title) {
            return props.title;
        }
        return "Formular";
    }, [heading, props.title]);
    return (React.createElement(Provider, { store: store },
        React.createElement(CacheProvider, { value: props.cache },
            React.createElement(ChakraProvider, { theme: theme, toastOptions: { portalProps: { containerRef: ref } } },
                React.createElement(Portal, { containerRef: ref },
                    React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "xl", isCentered: true },
                        React.createElement(ModalOverlay, null),
                        React.createElement(ModalContent, null,
                            React.createElement(ModalHeader, null, headerTitle),
                            React.createElement(ModalCloseButton, null),
                            React.createElement(ModalBody, { pb: 4 },
                                React.createElement(Form, { formId: props.formId, onLoad: (definition) => setHeading(definition.heading) }))))),
                React.createElement(Box, { ref: ref })))));
};
class ReaFormModalWebComponent extends HTMLElement {
    constructor() {
        super();
        this.root = null;
        this.openFn = null;
        this.triggerEl = null;
        this.clickHandler = null;
        this.mount();
    }
    connectedCallback() {
        this.attachTrigger();
    }
    disconnectedCallback() {
        this.detachTrigger();
        if (this.root) {
            // Let React unmount to cleanup
            this.root.unmount();
            this.root = null;
        }
    }
    getFormId() {
        const attr = this.getAttribute("form-id");
        if (attr == null || attr === "")
            return null;
        const parsed = parseInt(attr, 10);
        return isNaN(parsed) ? null : parsed;
    }
    getTriggerId() {
        const attr = this.getAttribute("trigger-id");
        if (attr == null || attr === "")
            return null;
        return attr;
    }
    getModalTitle() {
        const attr = this.getAttribute("modal-title");
        if (attr == null)
            return null;
        return attr;
    }
    attachTrigger() {
        const triggerId = this.getTriggerId();
        if (!triggerId)
            return;
        console.log("Attaching trigger", triggerId);
        this.triggerEl = document.getElementById(triggerId);
        if (!this.triggerEl)
            return;
        this.clickHandler = (e) => {
            e.preventDefault();
            if (this.openFn)
                this.openFn();
        };
        this.triggerEl.addEventListener('click', this.clickHandler);
    }
    detachTrigger() {
        if (this.triggerEl && this.clickHandler) {
            this.triggerEl.removeEventListener('click', this.clickHandler);
        }
        this.triggerEl = null;
        this.clickHandler = null;
    }
    mount() {
        const formId = this.getFormId();
        const title = this.getModalTitle();
        const shadowRoot = this.attachShadow({ mode: "open" });
        const container = document.createElement("div");
        shadowRoot.appendChild(container);
        const cache = createCache({
            container: shadowRoot,
            key: "c"
        });
        this.root = createRoot(container);
        this.root.render((React.createElement(React.Fragment, null, formId != null ? (React.createElement(WrapperWithModal, { formId: formId, cache: cache, bindOpen: (fn) => this.openFn = fn, title: title || undefined })) : null)));
    }
}
if (!customElements.get('rea-form-modal')) {
    customElements.define('rea-form-modal', ReaFormModalWebComponent);
}
